module.exports = "/assets/data/b4aed1a185c382617cae86258f6caaae-NR28.data.json";